function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Zeichenfl\\xE4che_7"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 28
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Zeichenfl\\xE4che_7",
  "data-name": "Zeichenfl\\xE4che \\u2013 7",
  clipPath: "url(#clip-Zeichenfl\\xE4che_7)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_2",
  "data-name": "Gruppe 2",
  transform: "translate(-40 -465)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_7",
  "data-name": "Rechteck 7",
  transform: "translate(42 467)",
  fill: "#e6e2e6",
  stroke: "#c6c6c6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("text", {
  id: "Esc",
  transform: "translate(47 483)",
  fontSize: 10,
  fontFamily: "SegoeUI, Segoe UI"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Esc"))));

var SvgEscKey = function SvgEscKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEscKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/esc-key.81d231ea.svg";
export { ForwardRef as ReactComponent };